module.exports = __webpack_public_path__ + "static/img/IMG_0903.15732d6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0903.jpeg
// module id = zmNf
// module chunks = 0